import React from 'react';
import classNames from 'classnames';
import { map, has } from 'lodash';
import { Icon } from 'components/ui';
import Tooltip from 'components/shared/Tooltip';
import { LabeledCheckbox } from 'components/shared/checkbox';

const labels = {
  get gradable() {
    return t('questions.gradable.label');
  },
  get required() {
    return t('questions.required.label');
  },
};

const isDisabled = (type, questionMetadata) => {
  switch (type) {
    case 'required':
      return (
        questionMetadata.isKnowledgeCheckElement ||
        questionMetadata.isInteractiveElement
      );
    case 'gradable':
      return (
        questionMetadata.hasFeedbackCriteria ||
        questionMetadata.isGraderNotesEnabled
      );
    default:
      return false;
  }
};

const renderOptions = (options, id, update, applyChanges, questionMetadata) =>
  map(options, (option, type) => (
    <LabeledCheckbox
      key={`${id}_${type}`}
      label={labels[type]}
      checked={option}
      onChange={e => {
        const change = { [type]: e.target.checked };
        update(change);
        applyChanges({ options: change });
      }}
      disabled={isDisabled(type, questionMetadata)}
    />
  ));
const TooltipText = () => (
  <span className="w-260 p-8 d-f fd-c text-wrap ws-pr fz-12 lh-16">
    <span>
      <span className="fw-b">{t('questions.question.tooltip.graded')}</span>
      {` - ${t('questions.question.tooltip.graded_explanation')}`}
    </span>
    <span className="pt-8">
      <span className="fw-b">{t('questions.question.tooltip.not_graded')}</span>
      {` - ${t('questions.question.tooltip.not_graded_explanation')}`}
    </span>
  </span>
);
const QuestionOptions = ({
  id,
  options,
  onChange,
  applyChanges,
  questionMetadata,
  isInteractiveElement,
}) => {
  const showTooltip = has(options, 'gradable');
  return (
    <div
      className={classNames('EditorElement-options', {
        interactiveElement: isInteractiveElement,
      })}
    >
      {renderOptions(options, id, onChange, applyChanges, questionMetadata)}
      {showTooltip && (
        <span className="d-ib ml-8 ">
          <Tooltip text={<TooltipText />}>
            <Icon name="info" className="c-gray-light" />
          </Tooltip>
        </span>
      )}
    </div>
  );
};

export default QuestionOptions;
